import { render, staticRenderFns } from "./component-0b2c6199.vue?vue&type=template&id=a12797f8&scoped=true&"
import script from "./component-0b2c6199.vue?vue&type=script&lang=js&"
export * from "./component-0b2c6199.vue?vue&type=script&lang=js&"
import style0 from "./component-0b2c6199.vue?vue&type=style&index=0&id=a12797f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a12797f8",
  null
  
)

export default component.exports